export default "__VITE_ASSET__M7rOE3FP__"